import { render, staticRenderFns } from "./chghost.vue?vue&type=template&id=7a131622&"
import script from "./chghost.vue?vue&type=script&lang=js&"
export * from "./chghost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports